import { getPlatformName } from "../config/config-store";
import { getApp } from "../experience.utils";
export const getKey = (config) => {
    return config.key || getPlatformName() || getApp();
};



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/utils/key.js
// module id = ./node_modules/@celine/passive-tracking/dist/utils/key.js
// module chunks = 0